// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"384":"05c1a825","453":"2f4e4f68","495":"2e2fccde"}[chunkId] + ".chunk.js";
};